import { type FunctionComponent, lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterCuratePageReviewStoreList = lazy(() => {
  return new Promise<{ default: FunctionComponent }>((resolve, reject) => {
    import("@honeycomb/curate/curate.css");
    import("@honeycomb/curate")
      .then((lib) => {
        resolve({
          default: () => <lib.ReviewStoreListPage />,
        });
      })
      .catch(reject);
  });
});

export const LazyCuratePageReviewStoreList = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterCuratePageReviewStoreList />
    </Suspense>
  );
};
